import React from 'react';
import { SVGProps } from '../../helpers/types';

const ChevronDown: React.FC<SVGProps> = () => {
  return (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.59 0.540955L6 5.12095L1.41 0.540955L0 1.95095L6 7.95095L12 1.95095L10.59 0.540955Z" fill="#8D8885" />
    </svg>
  );
};

export default ChevronDown;
